import React, { useEffect, useState, useContext } from 'react';
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Stack,
  Select,
  Button,
  MenuItem,
} from '@mui/material';
import { Visibility, Edit, Delete } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import demoRequestApi from '../../api/demoRequestApi';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { AuthContext } from '../../auth/AuthContext';

export default function RichiesteDemoListPage() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [requests, setRequests] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const pageSize = 10;

  useEffect(() => {
    fetchRequests(0);
  }, []);

  const fetchRequests = (page) => {
    demoRequestApi
      .list({ page, size: pageSize })
      .then(r => {
        setRequests(r.data.content || []);
        setTotalPages(r.data.totalPages || 0);
        setPage(r.data.number || 0);
      })
      .catch(console.error);
  };

  const openDeleteDialog = (id) => {
    setSelectedId(id);
    setOpenDeleteModal(true);
  };

  const closeDeleteDialog = () => {
    setSelectedId(null);
    setOpenDeleteModal(false);
  };

  const confirmDelete = async () => {
    try {
      await demoRequestApi.delete(selectedId);
      fetchRequests(page);
    } catch (err) {
      console.error(err);
    }
    closeDeleteDialog();
  };

const updateStatus = async (riga, nuovoStato) => {
  try {
    // Clona l'oggetto corrente e aggiorna solo stato
    const updatedForm = { ...riga, stato: nuovoStato, dataRichiesta:null };
    console.log("updatedForm",updatedForm);
    await demoRequestApi.updateStatus(riga.id, updatedForm);
    fetchRequests(page);
  } catch (err) {
    console.error(err);
  }
};

  return (
    <Container>
    <BackButtonDesktop />
      <Typography variant="h4" sx={{ mb: 2 }}>
        Richieste Demo
      </Typography>
      {/* PAGINAZIONE */}
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === page ? 'contained' : 'outlined'}
            onClick={() => fetchRequests(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell>Cognome</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Data richiesta</TableCell>
            <TableCell>Stato</TableCell>
            <TableCell>Azioni</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {requests.map(r => (
            <TableRow key={r.id}>
              <TableCell>{r.nome}</TableCell>
              <TableCell>{r.cognome}</TableCell>
              <TableCell>{r.email}</TableCell>
              <TableCell>
                {new Date(r.dataRichiesta).toLocaleDateString()}
              </TableCell>

              <TableCell>
                <ProtectedAction user={user} roles={['ADMIN']}>
                  <Select
                    size="small"
                    value={r.stato}
                    onChange={e => updateStatus(r, e.target.value)}
                  >
                    <MenuItem value="NUOVA">NUOVA</MenuItem>
                    <MenuItem value="IN_LAVORAZIONE">IN_LAVORAZIONE</MenuItem>
                    <MenuItem value="ACCETTATA">ACCETTATA</MenuItem>
                    <MenuItem value="RIFIUTATA">RIFIUTATA</MenuItem>
                  </Select>
                </ProtectedAction>

                {user.role !== 'ADMIN' && r.stato}
              </TableCell>

              <TableCell>
                <Stack direction="row">
               {/*
                  <IconButton
                    color="primary"
                    size="small"
                    onClick={() => navigate(`/demo-requests/${r.id}`)}
                  >
                    <Visibility />
                  </IconButton>

                  <ProtectedAction user={user} roles={['ADMIN']}>
                    <IconButton
                      color="secondary"
                      size="small"
                      onClick={() => navigate(`/demo-requests/edit/${r.id}`)}
                    >
                      <Edit />
                    </IconButton>

                    <IconButton
                      color="error"
                      size="small"
                      onClick={() => openDeleteDialog(r.id)}
                    >
                      <Delete />
                    </IconButton>
                  </ProtectedAction>*/}
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* PAGINAZIONE */}
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === page ? 'contained' : 'outlined'}
            onClick={() => fetchRequests(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>

      <ConfirmDeleteModal
        open={openDeleteModal}
        onCancel={closeDeleteDialog}
        onConfirm={confirmDelete}
        message="Sei sicuro di voler eliminare questa richiesta demo?"
      />
    </Container>
  );
}
